import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAppContext from "src/shared/components/withAppContext";
import withAxios from "src/shared/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
// import ArrowIcon from "src/assets/Arrow.png";
import LoadingSpinner from "src/shared/components/LoadingSpinner";
import { Link } from "react-router-dom";
// import { ZENDDESK_FAQ
//   // , ZENDESK_UPGRADE_PLAN 
// } from "src/constants";
export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public readonly state = this.buildState({
            loader: false,
            getAllPlanData: [],
            getAllAddonData: [],
            subscriptionPlan: {},
            activeContainer: [],
            upgradeDetails: {}
          });
          public componentDidMount() {
            this.getUpgradeDetails()
            this.getAllPlanHandler()

          }
          public getUpgradeDetails = () => {
            const storedObject: string = localStorage.getItem("upgradeDetails") || '{}';  // Fallback to an empty object string
            const parsedObject = JSON?.parse(storedObject);
            if (Object.keys(parsedObject).length > 0) {
              this.setState({ upgradeDetails: parsedObject })
            }
          }
          public async getAllPlanHandler() {
            this.setState({ loader: true })
            const res: any = await this.buildGet(this, "payment/getPlan")()
            console.log("plan details=====>", res)
            if (res.status && res?.data?.length > 0) {
              const data = res.data.sort((a: any, b: any) => a.id - b.id);
              this.setState({ getAllPlanData: data })
              this.setState({ loader: false })
            } else {
              this.setState({ loader: false })
            }
            // this.setState({ user: res })
          }

          public buyPlanHandler(item: any, type?: string) {
                const searchParams = new URLSearchParams(window.location.search);
                const membershipId = searchParams.get("membership_id");

            localStorage.setItem("upgradeDetails", JSON.stringify({ plan: item, membership_id: membershipId, type: type || ""  }));
          }

          // Handle plan click from pricing cards and prevent downgrades
          public handlePlanClick = (
            event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
            item: any,
            isActive: boolean
          ) => {
            const currentPlanId = this.props.userSubscription?.plans?.id;
            const targetPlanId = item?.id;

            // If user is trying to select a lower plan, block it
            if (currentPlanId && targetPlanId && Number(targetPlanId) < Number(currentPlanId)) {
              event.preventDefault();
              window.alert(
                "Plan downgrade is not allowed. Please select a plan that is equal to or higher than your current plan."
              );
              return;
            }

            this.buyPlanHandler(item, isActive ? "only-addons" : "");
          };
          
          public getFrequentyType(price: any, key: any) {
            switch (key) {
              case "free":
                return "Free"
              case "yearly":
                return `$${price}/yr`
              default:
                return ""
            }
          }
          public planRenderUI(item: any, index: any, isActive: boolean) {
            switch (item.id) {
              case 2:
                return this.starterPlanRender(item, index, isActive)
              case 3:
                return this.proPlanRender(item, index, isActive)
              case 4:
                return this.premierPlanRender(item, index, isActive)
              case 5:
                return this.elitePlanRender(item, index, isActive)
              default:
                return null
            }
          }
          public starterPlanRender(item: any, index: any, isActive: boolean) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (
              <div className="col-lg-12 p-0" key={index}>
                <div className="start-main-div">
                  <div className="starter">
                    <div className="starter-content">
                      <div className="fa-icon-dev">
                        <i className="fa-blue fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                      </div>
                      <div className="price-dev">
                        <div className="price-inner-content">
                          <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                        </div>

                      </div>
                    </div>
                    <div className="starter-inner-part">
                      <div className="starter-inner-content">
                                                                                    
                        {isActive && (
                          <div style={{ minHeight: "20px" }}>
                          <p style={{ color: "#8D6E00", fontWeight: "bold" }}>
                            This plan is already available.
                          </p>
                          </div>
                        )}


                        <h2 style={{marginTop: "5px"}}>{item.title}</h2>
                        <p>{item?.description}</p>
                        <h4>What’s Included? </h4>
                        <div className="start-list">
                          <ul>
                            {
                              tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                              }) : null
                            }
                          </ul>
                          <div className="buy-now-div">
  <Link
    to={`/${this.props.school?.slug}/addon-details${
      isActive ? "?type=only-addons" : ""
    }`}
    onClick={(e) => this.handlePlanClick(e, item, isActive)}
  >
    <button className="buy-now-btn">
      <span>{isActive ? "Buy Add-on" : "Buy Now"}</span>
    </button>
  </Link>
</div>

                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>)

          }
          public proPlanRender(item: any, index: any, isActive: boolean) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (
              <div className="col-lg-12 p-0 pl-0">
                <div className="pro">
                  <div className="starter">
                    <div className="starter-content">
                      <div className="fa-icon-dev">
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-blue fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                      </div>
                      <div className="price-dev">
                        <div className="price-inner-content">
                          <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                        </div>

                      </div>
                    </div>
                    <div className="starter-inner-part">
                      <div className="starter-inner-content">
                         
                      {isActive && (
                        <div style={{ minHeight: "20px" }}>
                        <p style={{ color: "#8D6E00", fontWeight: "bold" }}>
                          This plan is already available.
                        </p>
                        </div>
                      )}


                        <h2 style={{marginTop: "5px"}}>{item?.title}</h2>
                        <p>{item?.description}</p>
                        <h4>What’s Included? </h4>
                        <div className="start-list">
                          <ul className="pro-ul">
                            {
                              tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                              }) : null
                            }

                          </ul>
                          <div className="buy-now-div">
  <Link
    to={`/${this.props.school?.slug}/addon-details${
      isActive ? "?type=only-addons" : ""
    }`}
    onClick={(e) => this.handlePlanClick(e, item, isActive)}
  >
    <button className="buy-now-btn">
      <span>{isActive ? "Buy Add-on" : "Buy Now"}</span>
    </button>
  </Link>
</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          public premierPlanRender(item: any, index: any, isActive: boolean) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (<div className="col-lg-12 p-0 pl-0">
              <div className="premier">
                <div className="starter">
                  <div className="starter-content">
                    <div className="fa-icon-dev">
                      <i className="fa-grey fa-solid fa-circle" />
                      <i className="fa-grey fa-solid fa-circle" />
                      <i className="fa-blue fa-solid fa-circle" />
                      <i className="fa-grey fa-solid fa-circle" />
                    </div>
                    <div className="price-dev">
                      <div className="price-inner-content">
                        <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                      </div>

                    </div>
                  </div>
                  <div className="starter-inner-part">
                    <div className="starter-inner-content">
                      <div
  className="most-popular"
  style={{ 
   
    display: "flex",
    flexDirection: "column"   // 👈 forces NEW LINES
  }}
>

  {/* Row 1 */}
 
    {isActive && (
      <div style={{ minHeight: "20px" }}>
      <p style={{ color: "#8D6E00", fontWeight: "bold", margin: 0 }}>
        This plan is already available.
      </p>
      </div> 
    )}
 

  {/* Row 2 */}
  <h2 style={{ margin: "5px 0 0 0" }}>{item?.title}</h2>

  {/* Row 3 */}
  <div className="most-inner-popular">
    <h4 style={{ margin: "0" }}>Most Popular</h4>
  </div>




</div>

                      <p>{item?.description}</p>
                      <h4>What’s Included? </h4>
                      <div className="start-list">
                        <ul className="premier-ul">
                          {
                            tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                              return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                            }) : null
                          }
                        </ul>
                        <div className="buy-now-div">
  <Link
    to={`/${this.props.school?.slug}/addon-details${
      isActive ? "?type=only-addons" : ""
    }`}
    onClick={(e) => this.handlePlanClick(e, item, isActive)}
  >
    <button className="buy-now-btn">
      <span>{isActive ? "Buy Add-on" : "Buy Now"}</span>
    </button>
  </Link>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>)
          }

          public elitePlanRender(item: any, index: any, isActive: boolean) {
            const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
            return (
              <div className="col-lg-12 p-0 pl-0">
                <div className="elite">
                  <div className="starter">
                    <div className="starter-content">
                      <div className="fa-icon-dev">
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-grey fa-solid fa-circle" />
                        <i className="fa-blue fa-solid fa-circle" />
                      </div>
                      <div className="price-dev">
                        <div className="price-inner-content">
                          <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                        </div>

                      </div>
                    </div>
                    <div className="elite-inner-part">
                      <div className="elite-inner-content">
                      
  {isActive && (
      <div style={{ minHeight: "20px" }}>
    <p style={{ color: "#8D6E00", fontWeight: "bold" }}>
      This plan is already available.
    </p>
    </div>
  )}


                        <h2 style={{marginTop: "5px"}}>{item?.title}</h2>
                        <p>{item?.description}</p>
                        <h4>What’s Included? </h4>
                        <div className="elite-list">
                          <ul className="elite-ul">
                            {
                              tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                              }) : null
                            }
                          </ul>
                          <div className="buy-now-div">
  <Link
    to={`/${this.props.school?.slug}/addon-details${
      isActive ? "?type=only-addons" : ""
    }`}
    onClick={(e) => this.handlePlanClick(e, item, isActive)}
  >
    <button className="buy-now-btn">
      <span>{isActive ? "Buy Add-on" : "Buy Now"}</span>
    </button>
  </Link>
</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          public render() {
            const {
              appContext: { user, baseUri },
              classes,
            } = this.props;
            console.log(user, classes, baseUri)

            return (
                <div>
              {this.state.loader &&<div className="loader-bg-color">
                <LoadingSpinner /></div>}
              <Page
                header={'Subscription Plans'}
                subtitle={''}
              >
                <div>
                  <div className="containerr">
                    <div className="pricing-main-div">
                      <h4 style={{ textAlign: "center" }} className="wanttoupgrade">Want to Upgrade?</h4>
                    {/* <div className="culture-content">
                      
                        <div className="culture-inner-content" style={{paddingTop:"20px"}}>
                          <p>Your current plan is <b>{this.props.userSubscription?.plans?.title }</b>. 
                            If you want to add on to this plan click the button of that plan. <br /> If you <b>want to upgrade</b> your plan to a new level select that plan. </p>
                        </div>

                      </div> */}

                      <div className="row p-2" style={{display:"flex",alignItems:'flex-end'}}>
                        {/* {
                          this.state.getAllPlanData?.filter((item: any) => item?.id !== 1).map((item: any, index: number) => {
                            return this.planRenderUI(item, index)
                          })
                        } */}

                        {
                              this.state.getAllPlanData
                                ?.filter((item: any) => item?.id !== 1)
                                .map((item: any, index: number) => {
                                  const activePlanId = this.props.userSubscription?.plans?.id; // your logged id (e.g. 5)
                                  const isActive = item.id === activePlanId; // check match
                                  

                                  return (
                                    <div
                                      key={item.id}
                                       className={`col-lg-3 ${isActive ? "active" : ""}`}
                                    >
                                      {this.planRenderUI(item, index, isActive)}
                                    </div>
                                  );
                                })
                            }


                        {/* {
                          console.log("statttttttttttttt:::::::", this.state)                       
                          
                          }
                        {
                           console.log("dddddddddddddddddtt:::::::", this.props.userSubscription.plans.id)
                        } */}
                        {/* <div className="col-lg-3">
                                        <div className="pro">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="starter-inner-part">
                                                    <div className="starter-inner-content">
                                                        <h2>Pro</h2>
                                                        <p>For schools who are just getting started with coaching leadership development.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="start-list">
                                                            <ul className="pro-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>


                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <Link to="/propage"><button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button></Link>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="premier">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="starter-inner-part">
                                                    <div className="starter-inner-content">
                                                        <h2>Premier</h2>
                                                        <p>For schools who are just getting started with coaching leadership development.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="start-list">
                                                            <ul className="premier-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>

                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <Link to="/premierpage"> <button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button></Link>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="elite">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="elite-inner-part">
                                                    <div className="elite-inner-content">
                                                        <h2>Elite</h2>
                                                        <p>For schools that want unlimited access to build coaches, culture, and athletic director leadership.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="elite-list">
                                                            <ul className="elite-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div> */}

                      </div>

                      {/* <div className="culture-content">
                        <div className="culture-inner-content">
                          <h2>Culture and Coach Training</h2>
                          <p>If you want more than just an opinion survey system, culture and coach training for your staff and your community is what's next.</p>
                          <button className="culture-btn" onClick={()=>{
                            window.open(ZENDDESK_FAQ)
                          }}><span>CONTACT US</span></button>
                        </div>

                      </div> */}
                    </div>
                  </div>
                </div>
                
              </Page>
              </div>
            );
          }


        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/upgradeSubscription/subscriptionPlanUpgrade.tsx